import {useState} from "react";
import {FacebookShareButton, TwitterShareButton, LinkedinShareButton} from "react-share";
import {logAnalytics} from "../utils/firebase-util";

const NavBar = () => {
    const [navbarOpen, setNavbarOpen] = useState(false);
    return (
        <>
            <nav className="relative flex flex-wrap items-center justify-between px-2 py-3 bg-gray-800 mb-3">
                <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
                    <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
                        <a
                            className="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-white"
                            href="/"
                        >
                            JHB IT Institute
                        </a>
                        <button
                            className="text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
                            type="button"
                            onClick={() => setNavbarOpen(!navbarOpen)}
                        >
                            <i className="fas fa-bars"></i>
                        </button>
                    </div>
                    <div
                        className={
                            "lg:flex flex-grow items-center" +
                            (navbarOpen ? " flex" : " hidden")
                        }
                        id="example-navbar-danger"
                    >
                        <ul className="flex flex-col lg:flex-row list-none lg:ml-auto">
                            <li className="nav-item">
                                <div
                                    onClick={() => logAnalytics("facebook_share_button")}
                                    className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
                                >
                                    <FacebookShareButton
                                        url={window.location.href}
                                        title="Register for a class!"
                                    >
                                        <i className="fab fa-facebook-square text-lg leading-lg text-white opacity-75"></i><span
                                        className="ml-2">Share</span>
                                    </FacebookShareButton>
                                </div>
                            </li>
                            <li className="nav-item">
                                <div
                                    onClick={() => logAnalytics("twitter_share_button")}
                                    className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
                                >
                                    <TwitterShareButton
                                        url={window.location.href}
                                        title="Register for a class!"
                                    >
                                        <i className="fab fa-twitter text-lg leading-lg text-white opacity-75"></i><span
                                        className="ml-2">Tweet</span>
                                    </TwitterShareButton>
                                </div>
                            </li>
                            <li className="nav-item">
                                <div
                                    onClick={() => logAnalytics("linkedin_share_button")}
                                    className="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:opacity-75"
                                >
                                    <LinkedinShareButton
                                        url={window.location.href}
                                        title="Register for a class!"
                                    >
                                        <i className="fab fa-linkedin text-lg leading-lg text-white opacity-75"></i><span
                                        className="ml-2">Share</span>
                                    </LinkedinShareButton>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default NavBar;